/*
* @Author: tong.yu
* @Date:   2021-09-16 14:47:59
* @Last Modified by: tong.yu
* @Last Modified time: 2021-09-Th 03:00:30
*/
import React from 'react';
import { Layout, Menu } from 'antd';
import routes from 'router/router.js';
import { withRouter } from 'react-router-dom';
import utils from 'utils/index';

const { Header, Content } = Layout;


// import NavTop from './nav-top/index.jsx';
// import NavSide from './nav-side/index.jsx';

class DefaultLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            current:props.location.pathname
        }
    }
    // 切换菜单页
    onChangeMenu(values){
        this.setState({current:values.key})
        this.props.history.push(values.key)
    }
    render() {
        const {
            current
        } = this.state;
        return (
            <Layout id="wrapper" className="layout-wrapper">
                <Header className="header" style={{display:'flex'}}>
                    <div className="logo">
                        <img src={utils.imgList.logo} alt="logo" style={{width:'100%'}}/>
                    </div>
                    <Menu theme="dark" mode="horizontal" selectedKeys={current} defaultSelectedKeys={['/account']} onSelect={(e)=>this.onChangeMenu(e)}>
                        {
                            routes.filter(page=>page.type&&page.type==='nav')
                            .map(route=>(
                                <Menu.Item key={route.path}>{route.pathName}</Menu.Item>
                            ))
                        }
                    </Menu>
                </Header>
                <Layout style={{ background:'#fff' }}>
                    <Content
                        className="site-layout-background"
                        style={{
                            margin: 0,
                            minHeight: 280,
                        }}
                    >
                        {this.props.children}
                    </Content>
                </Layout>
            </Layout>

        );
    }
}

export default withRouter(DefaultLayout);